<template>
  <div>
    <v-container>
      <v-row justify="center">
        <h1>Personal Data</h1>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center">
        <p>Basic information (such as name and photo) that you use in TRADEinPOOL</p>
      </v-row>
    </v-container>

    <h2>Profile</h2>

    <div class="record-card mt-2" @click="toggleShow">
      <div class="tag">Profile Picture</div>
      <div class="tag-value float-left mt-2">Upload photo to personalize your account</div>
      <div class="float-right">
        <Avatar style="border: 2px solid #333b47;" :username="username" :src="avatar" :size="80"></Avatar>
      </div>
    </div>

    <v-dialog v-model="editUsername" max-width="400px">
      <template v-slot:activator="{ on }">
        <div class="record-card mt-2" v-on="on">
          <div class="tag">Username</div>
          <div class="tag-value float-left mt-2">{{username}}</div>
          <div class="float-right">
            <v-icon color="#b6c1cb">edit</v-icon>
          </div>
        </div>
      </template>
      <editUsername @close="closeModal" />
    </v-dialog>

    <v-dialog v-model="editBirth" max-width="290px">
      <template v-slot:activator="{ on }">
    <div class="record-card mt-2"  v-on="on">
      <div class="tag">Birth</div>
      <div class="tag-value float-left mt-2">{{birth}}</div>
      <div class="float-right">
        <v-icon color="#b6c1cb">edit</v-icon>
      </div>
    </div>
    </template>
      <editBirth @close="closeModal" />
    </v-dialog>

    <v-dialog v-model="editGender" max-width="400px">
      <template v-slot:activator="{ on }">
    <div class="record-card mt-2" v-on="on">
      <div class="tag">Gender</div>
      <div class="tag-value float-left mt-2">{{gender}}</div>
      <div class="float-right">
        <v-icon color="#b6c1cb">edit</v-icon>
      </div>
    </div>
    </template>
      <editGender @close="closeModal" />
    </v-dialog>

    <v-dialog v-model="editPassword" max-width="400px">
      <template v-slot:activator="{ on }">
    <div class="record-card mt-2"  v-on="on">
      <div class="tag">Password</div>
      <div class="tag-value float-left mt-2">••••••••••••</div>
      <div class="float-right">
        <v-icon color="#b6c1cb">edit</v-icon>
      </div>
    </div>
    </template>
      <editPassword @close="closeModal" />
    </v-dialog>


    <h2>Contact</h2>
    <div class="record-card mt-2 low-opacity">
      <div class="tag">Email</div>
      <div class="tag-value float-left mt-2">{{email}}</div>
      <div class="float-right">
        
      </div>
    </div>
  

    <my-upload
      class="avatar-modal"
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      
      v-model="show"
      :width="200"
      :height="200"
      url="https://tradeinpool.com:3001/api/upload/avatar"
      :params="params"
      :headers="headers"
      img-format="png"
      langType="en"
      :noSquare="true"
    ></my-upload>
  </div>
</template>

<script>
var moment = require("moment");
import Avatar from "vue-avatar";
import myUpload from "vue-image-crop-upload";
import editUsername from "./editUsername";
import editPassword from "./editPassword";
import editBirth from "./editBirth";
import editGender from "./editGender";
export default {
  name: "PersonalData",
  components: {
    "my-upload": myUpload,
    editUsername,
    editPassword,
    editBirth,
    editGender,
    Avatar
  },
  data() {
    return {
      email: this.$store.getters.usermail,
      editAvatar: false,
      editUsername: false,
      editBirth: false,
      editGender: false,
      editPassword: false,
      //crop avatar,
      server: `${this.$store.getters.apiServer}/api/upload/avatar`,
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        Authorization: `Token ${this.$store.getters.userToken}`
      },
      imgDataUrl: "" // the datebase64 url of created image
    };
  },
  computed: {
    avatar() {
      if (this.$store.getters.avatar)
        return `https://tradeinpool.com/upload/${this.$store.getters.avatar}.png`;
      else return null
    },
    username(){
      return this.$store.getters.username
    },
    birth(){
      if(this.$store.getters.birth != null)
      return moment(this.$store.getters.birth).format("YYYY-MM-DD")
       
      else
      return "N/A"
    },
    gender(){
      if(this.$store.getters.gender != null)
      return this.$store.getters.gender
      else
      return "N/A"
    }
  },
  mounted() {},
  methods: {
    closeModal(val) {
      this[val] = false;
    },
    toggleShow() {
      this.show = !this.show;
    },
    //cropSuccess(imgDataUrl, field) {
      cropSuccess(imgDataUrl) {
      //console.log('-------- crop success --------');
      this.imgDataUrl = imgDataUrl;
    },
    //cropUploadSuccess(jsonData, field) {
    cropUploadSuccess() {
      if (localStorage.getItem("access_token")) {
        this.$store.dispatch("getUserdata").catch(() => {
          this.$router.push({ name: "home" });
          alert("App loading API failed");
        });
      }
    },
    //cropUploadFail(status, field) {
      //console.log("-------- upload fail --------");
      //console.log(status);
      //console.log("field: " + field);
    //},
    
  }
};
</script>

<style scoped>
h2 {
  color: #4dbac0;
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif !important;
  font-size: 16px;
}
.record-card {
  width: 100%;
  float: left;
  background-color: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  cursor: pointer;
  font-size: 12px;
}

.record-card:hover {
  background: #232a35;
}
.tag {
  color: #b6c1cb;
  text-transform: uppercase;
}
.tag-value {
  font-size: 16px;
}
.avatar {
  border: 10px solid #333b47;
}
</style>